import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { Accordion, AccordionDetails, AccordionSummary, Button, Checkbox, FormControlLabel, Grid } from "@mui/material";
import { styled } from "@mui/material/styles";
import { each, get } from "lodash";
import React from "react";
import { propertyTypeFilters } from "./constants";

const StyledAccordion = styled(Accordion)({
    margin: 0,
    borderTop: "1px solid #eeeeee",
});

const StyledAccordionSummary = styled(AccordionSummary)({
    minHeight: "0 !important",
    "&.Mui-expanded": {
        margin: "0 !important",
        background: "#fafafa",
    },
    "& .MuiAccordionSummary-content": {
        margin: 0,
    },
    margin: 0,
});

const StyledAccordionDetails = styled(AccordionDetails)({
    padding: "0 20px",
    borderTop: "1px solid #eeeeee",
});

const StyledMenuSectionTitle = styled("h4")({
    color: "#9E9E9E",
    fontSize: "13px",
    fontWeight: 600,
    textTransform: "uppercase",
    marginBottom: "5px",
});

const StyledMenuButton = styled(Button)({
    margin: "15px",
});

const PropertyTypeFilter = (props) => {
    const {
        updateFilter,
        handleSelectAllPropertyType,
        handleSearchSubmit,
        searchCriteria,
        togglePropertyTypeExpansionPanel,
        propertyTypeExpansionPanels,
    } = props;

    const updatePropertyTypeFilter = (field, value) => {
        updateFilter(field, value);
    };

    const propertyTypeCriteria = searchCriteria.propertyTypes;

    const countPropertyTypeSelectedSubtype = (searchCriteria) => {
        let count = 0;
        each(Object.keys(get(searchCriteria, "specialtyTypeCriteria", {})), (key) => {
            if (get(searchCriteria, `specialtyTypeCriteria.${key}`, false) === true) {
                count += 1;
            }
        });
        each(Object.keys(get(searchCriteria, "buildlingClassCriteria", {})), (key) => {
            if (get(searchCriteria, `buildlingClassCriteria.${key}`, false) === true) {
                count += 1;
            }
        });
        return count;
    };

    const checkForLeaseOnly = () => {
        console.log(searchCriteria);
        if (
            (!get(searchCriteria, "dealTypeCriteria.sublease") &&
                !get(searchCriteria, "dealTypeCriteria.investmentSaleFlg") &&
                !get(searchCriteria, "dealTypeCriteria.sale") &&
                get(searchCriteria, "dealTypeCriteria.lease")) ||
            (!get(searchCriteria, "listingTypeCriteria.forSublease") &&
                !get(searchCriteria, "listingTypeCriteria.investmentSaleFlg") &&
                !get(searchCriteria, "listingTypeCriteria.forSale") &&
                get(searchCriteria, "listingTypeCriteria.forLease"))
        ) {
            return true;
        }
        return false;
    };

    return (
        <Grid container>
            {Object.keys(propertyTypeFilters).map(
                (type) =>
                    !(type === "Hospitality" && checkForLeaseOnly()) && (
                        <Grid
                            sx={{ flexGrow: 0, flexBasis: "100%", maxWidth: "100%", minWidth: "Auto" }}
                            size={{ xs: 12 }}
                        >
                            <StyledAccordion expanded={get(propertyTypeExpansionPanels, type, false)}>
                                <StyledAccordionSummary
                                    expandIcon={
                                        <ExpandMoreIcon
                                            onClick={() => {
                                                togglePropertyTypeExpansionPanel(type);
                                            }}
                                        />
                                    }
                                >
                                    <Grid container>
                                        <Grid>
                                            <FormControlLabel
                                                control={
                                                    <Checkbox
                                                        checked={get(propertyTypeCriteria, `${type}.selected`, false)}
                                                        onChange={(e) =>
                                                            handleSelectAllPropertyType(type, e.target.checked)
                                                        }
                                                        color="primary"
                                                    />
                                                }
                                                label={`${propertyTypeFilters[type]["display"]} ${
                                                    countPropertyTypeSelectedSubtype(
                                                        get(propertyTypeCriteria, type, {})
                                                    ) > 0
                                                        ? `(${countPropertyTypeSelectedSubtype(
                                                              get(propertyTypeCriteria, type, {})
                                                          )})`
                                                        : ""
                                                }`}
                                            />
                                        </Grid>
                                    </Grid>
                                </StyledAccordionSummary>
                                <StyledAccordionDetails>
                                    <Grid container>
                                        {Object.keys(propertyTypeFilters[type]["subs"]).map((sub) => {
                                            const subType = propertyTypeFilters[type]["subs"][sub];
                                            return (
                                                <React.Fragment>
                                                    {/* check if gridItemCheckbox style is present in dev branch */}
                                                    <Grid
                                                        sx={{
                                                            flexGrow: 0,
                                                            flexBasis: "100%",
                                                            maxWidth: "100%",
                                                            minWidth: "0",
                                                        }}
                                                        size={{ xs: 12 }}
                                                    >
                                                        <StyledMenuSectionTitle>
                                                            {subType.display}
                                                        </StyledMenuSectionTitle>
                                                    </Grid>
                                                    {Object.keys(subType.options).map((opt) => {
                                                        const option = subType["options"][opt];
                                                        return (
                                                            <Grid
                                                                sx={{
                                                                    flexGrow: 0,
                                                                    flexBasis: "50%",
                                                                    maxWidth: "50%",
                                                                    minWidth: "0",
                                                                }}
                                                                size={{ xs: 6 }}
                                                            >
                                                                <FormControlLabel
                                                                    control={
                                                                        <Checkbox
                                                                            checked={get(
                                                                                propertyTypeCriteria,
                                                                                `${type}.${sub}.${opt}`,
                                                                                false
                                                                            )}
                                                                            onChange={(e) =>
                                                                                updatePropertyTypeFilter(
                                                                                    `propertyTypes.${type}.${sub}.${opt}`,
                                                                                    e.target.checked
                                                                                )
                                                                            }
                                                                            color="primary"
                                                                        />
                                                                    }
                                                                    label={option.display}
                                                                />
                                                            </Grid>
                                                        );
                                                    })}
                                                </React.Fragment>
                                            );
                                        })}
                                    </Grid>
                                </StyledAccordionDetails>
                            </StyledAccordion>
                        </Grid>
                    )
            )}
            <div
                style={{
                    display: "flex",
                    justifyContent: "flex-end",
                    flexWrap: "wrap",
                    boxSizing: "borderBox",
                    margin: "-8px",
                    width: "100%",
                }}
            >
                <div>
                    <StyledMenuButton variant="contained" color="primary" onClick={handleSearchSubmit}>
                        Search
                    </StyledMenuButton>
                </div>
            </div>
        </Grid>
    );
};

export default PropertyTypeFilter;
